export default __webpack_public_path__ + "static/media/rain_thunder.dae22e4a.svg";